import { styled } from '@mui/material';

export const AddressCountryBranding = styled('img')({
  width: 206,
});
